// import { Level } from 'chalk';

export const routes = [
    {
        path: '/',
        redirect: "/login",
        meta: {
            show: false, //判断是否展示菜单栏
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/login'),
        meta: {
            title: "登录",
            show: false,
        },
    },
    {
        path: '/car',
        name: 'car',
        component: () => import('@/pages/common'),
        meta: {
            title: "车辆管理",
            icon: "el-icon-truck",
            show: true,
        },
        children: [
            // {
            //     path: 'status',
            //     name: 'car-status',
            //     component: () => import('../pages/car/status/index.vue'),
            //     meta: {
            //         title: "车辆状态",
            //         show: true,
            //     },
            // },
            {
                path: 'condition',
                name: 'car-condition',
                component: () => import('../pages/car/status/index.vue'),
                meta: {
                    title: "车辆状态",
                    show: true,
                },
            },
            {
                path: 'logs',
                name: 'car-logs',
                component: () => import('@/pages/car/logs'),
                meta: {
                    title: "车辆日志",
                    show: true,
                },
            },
            {
                path: 'position',
                name: 'car-position',
                component: () => import('@/pages/car/position'),
                meta: {
                    title: "车辆位置可视化",
                    show: false,
                },
            },
            // {
            //     path: 'delivery',
            //     name: 'car-delivery',
            //     component: () => import('@/pages/car/delivery'),
            //     meta: {
            //         title: "车辆配送",
            //         show: true,
            //     },
            // },
            // {
            //     path: 'camera',
            //     name: 'car-camera',
            //     component: () => import('@/pages/camera'),
            //     meta: {
            //         title: "视频监控",
            //         show: true,
            //     },
            // }
        ]
    },
    {
        path: '/property',
        name: 'property',
        component: () => import('@/pages/common'),
        meta: {
            title: "资产管理",
            icon: "el-icon-s-platform",
            show: true,
            level:2,
        },
        children: [
            {
                path: 'list',
                name: 'property-list',
                component: () => import('@/pages/property'),
                meta: {
                    title: "设备资产",
                    show: true,
                },
            },
        ]
    },
    {
        path: '/map',
        name: 'map',
        component: () => import('@/pages/common'),
        meta: {
            title: "地图管理",
            icon: "el-icon-map-location",
            show: true,
            // level: 2,
        },
        children: [
            {
                path: 'list',
                name: 'map-list',
                component: () => import('@/pages/map/list'),
                meta: {
                    title: "地图列表",
                    show: true,
                },
            },
            {
                path: 'details',
                name: 'map-details',
                component: () => import('@/pages/map/details'),
                meta: {
                    title: "地图详情",
                    show: false,
                },
            },
            {
                path: 'release',
                name: 'map-release',
                component: () => import('@/pages/map/release'),
                meta: {
                    title: "地图推送",
                    show: false,
                },
            }
        ]
    },
    {
        path: '/task',
        name: 'task',
        component: () => import('@/pages/common'),
        meta: {
            title: "任务管理",
            icon: "el-icon-share",
            show: true,
        },
        children: [
            // {
            //     path: 'board',
            //     name: 'task-board',
            //     component: () => import('@/pages/task/board'),
            //     meta: {
            //         title: "任务看板",
            //         show: true,
            //     },
            // },
            {
                path: 'list',
                name: 'task-list',
                component: () => import('@/pages/task/list'),
                meta: {
                    title: "任务列表",
                    show: true,
                },
            },
            {
                path: 'detail',
                name: 'task-detail',
                component: () => import('@/pages/task/detail'),
                meta: {
                    title: "任务详情",
                    show: false,
                },
            },
        ]
    },
    {
        path: '/workorder',
        name: 'workorder',
        component: () => import('@/pages/common'),
        meta: {
            title: "工单管理",
            icon: "el-icon-s-order",
            show: true,
            // level: 2,
        },
        children: [
            {
                path: 'afterSale',
                name: 'workorder-afterSale',
                component: () => import('@/pages/workorder/after-sale'),
                meta: {
                    title: "售后工单",
                    show: true,
                },
            },
            {
                path: 'recharge',
                name: 'workorder-recharge',
                component: () => import('@/pages/workorder/recharge'),
                meta: {
                    title: "订单列表",
                    show: false,
                },
            },
            {
                path: 'recharge/confirm/:orderId',
                name: 'workorder-recharge-confirm',
                component: () => import('@/pages/workorder/recharge/confirm-order'),
                meta: {
                    title: "订单确认",
                    show: false,
                },
            },
        ]
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/pages/common'),
        meta: {
            title: "仪表盘",
            icon: "el-icon-data-board",
            show: true,
        },
        children: [
            {
                path: 'board',
                name: 'dashboard-board',
                component: () => import('@/pages/dashboard/board'),
                meta: {
                    title: "日度统计",
                    show: true,
                },
            },
            {
                path: 'month',
                name: 'dashboard-month',
                component: () => import('@/pages/dashboard/month'),
                meta: {
                    title: "月度图表",
                    show: true,
                },
            }
        ]
    },
    {
        path: '/user',
        name: 'user',
        component: () => import('@/pages/common'),
        meta: {
            title: "账号管理",
            icon:"el-icon-user",
            show: true,
            level: 2,
        },
        children: [
            {
                path: 'list',
                name: 'user-list',
                component: () => import('@/pages/user'),
                meta: {
                    title: "登录账号配置",
                    show: true,
                },
            },
            {
                path: 'account',
                name: 'user-account',
                component: () => import('@/pages/user/account'),
                meta: {
                    title: "子账号列表",
                    show: true,
                },
            }
        ]
    },
    {
        path: '/system',
        name: 'system',
        component: () => import('@/pages/common'),
        meta: {
            title: "系统管理",
            icon: "el-icon-s-tools",
            show: true,
            level: 2,
        },
        children: [
            {
                path: 'details',
                name: 'system-details',
                component: () => import('@/pages/system'),
                meta: {
                    title: "系统配置",
                    show: true,
                },
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/router.config.js